quoteModule.factory("CustomerCard", function() {
    var CustomerCard = function(){
        this.CustomerName = 0;
        this.stockNumber = "";
        this.dmsDealNumber = "";
    }

    return CustomerCard;
});

